import { z } from 'zod';

export const rawIssueRelationshipCountSchema = z.object({
  relationship_count: z.number(),
});
export type RawIssueRelationshipCountSchema = z.infer<
  typeof rawIssueRelationshipCountSchema
>;

export const issueRelationshipCountSchema =
  rawIssueRelationshipCountSchema.transform((data) => ({
    relationshipCount: data.relationship_count,
  }));

export type IssueRelationshipCountEntity = z.infer<
  typeof issueRelationshipCountSchema
>;
